import styled from 'styled-components';

/*
 * The toast layer is ALWAYS mounted, empty or not: 320x8 of fixed, z-index 10 div pinned to the
 * top right. That is exactly where a page header's right-hand control sits, so with pointer events
 * it silently ate clicks on the booking-details "My bookings" button -- no notification in sight,
 * just a dead band across the middle of the button.
 *
 * The layer itself is a positioning shell and should never be a click target. Events pass straight
 * through it; the notification inside takes them back, because it has a close button of its own.
 */
export const Root = styled.div`
  position: fixed;
  padding: 4px;
  width: 320px;
  box-sizing: border-box;
  top: 1em;
  right: 1em;
  z-index: 10;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }

  @media only screen and (max-width: 480px) {
    width: 100vw;
    padding: 0;
    left: 0;
    margin: 0;
    top: 0;
    transform: translateX(0);
  }
`;
